// src/services/printRequest.service.js
import axiosInstance from "../utils/axiosInstance";
import { printRequestsUrl, realTimePrintRequestsByStoreUrl } from "../utils/urls";
import { addRequest, setRequests } from "../store/printRequestSlice";
import { toast } from "react-hot-toast";

let eventSource = null;

export const initPrintRequestStream = (storeId, dispatch) => {
  if (!storeId) return;
  const url = realTimePrintRequestsByStoreUrl(storeId);
  eventSource = new EventSource(url);

  eventSource.addEventListener("initial-data-chunk", (event) => {
    const data = JSON.parse(event.data);
    if (Array.isArray(data)) {
      dispatch(setRequests(data));
    } else {
      dispatch(addRequest(data));
      toast.success(`${data?.customer?.name || "Customer"} requested print request!`);
    }
  });

  eventSource.onmessage = () => {};
  eventSource.onerror = (error) => {
    console.error("EventSource error:", error);
    closePrintRequestStream();
  };
};

export const closePrintRequestStream = () => {
  if (eventSource) {
    eventSource.close();
    eventSource = null;
  }
};

/**
 * Fetch paginated print requests filtered by optional status and filters.
 * - If status is omitted, the API returns all statuses for the given storeId.
 * - Filters map directly to API query (requestId, customerName, deliverySlotId, startDate, endDate, page, limit).
 */
export const fetchPrintRequestsByStatus = async (storeId, status, filters = {}) => {
  if (!storeId) return []; // only storeId is required for "all statuses" per API docs
  try {
    const {
      size, // legacy alias -> limit
      ...rest
    } = filters;

    // Build params conditionally; omit undefined keys so Axios doesn't send them
    const params = {
      storeId,
      ...(status ? { status } : {}),        // omit entirely if status is falsy
      ...rest,
      ...(typeof size === "number" ? { limit: size } : {}), // map size->limit if provided
    };

    // Optionally strip empty string params as well
    Object.keys(params).forEach((k) => {
      if (typeof params[k] === "undefined" || params[k] === "") delete params[k];
    });

    const response = await axiosInstance.get(printRequestsUrl, { params });
    return response?.data?.data ?? []; // API returns { data: [...] }
  } catch (error) {
    console.error(`Failed to fetch requests:`, error);
    return [];
  }
};
